module.exports = __webpack_public_path__ + "static/img/interturis-2.07251e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/interturis-2.jpg
// module id = MojG
// module chunks = 1